export default class {

    public static unboxFunction(fnOrObj: any, args: any) {
        if (fnOrObj == null)
            return null;

        return typeof fnOrObj === 'function'
            ? fnOrObj.call(args)
            : fnOrObj;
    }

    public static getElemFromRefs(refs: any, id: string): HTMLElement {
        return (refs[id] as any)?.[0] as HTMLElement ?? null;
    }

    public static RemoveAttributesRecursive(root: Element, fnPredicate: (attr: Attr) => boolean) {

        const fnGo = (root: Element, fnPredicate: (attr: Attr) => boolean) => {
            Array.from(root.attributes).forEach(attr => {
                if (fnPredicate(attr) === true) {
                    root.attributes.removeNamedItemNS(null, attr.nodeName);
                }
            });

            //Recurse children
            Array.from(root.children).forEach(child => {
                fnGo(child, fnPredicate);
            });
        };

        fnGo(root, fnPredicate);

        return root;    //Chainable
    }

};